export const EXAMPLE = "/example";
///---------------------------------Message----------------------------------------
export const GROUPS = "groups";
///---------------------------------Direct Message----------------------------------------
export const DIRECT_MESSAGES = (id: any) => {
  return `direct-message/${id}`;
};

export const MESSSAGES = (groupId: any) => {
  return `groups/${groupId}/messages`;
};

export const STATISTICS = "/statistics";

//-----------------------------Authentication-Passkey----------------

export const VERIFY_LOGIN = "/auth/passkey/verify-login";
export const REQUEST_LOGIN = "/auth/passkey/request-login";
export const VERIFY = "/auth/passkey/verify";
export const REGISTER = "/auth/passkey/register";
